import { render, staticRenderFns } from "./VincularTarefaModalComponent.vue?vue&type=template&id=7e5291e2"
import script from "./VincularTarefaModalComponent.vue?vue&type=script&lang=js"
export * from "./VincularTarefaModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports